<template>
    <footer class="footer" v-if="setup != null" id="footer">
        <div class="container">
            <div class="col-container">
                <div class="col">
                    <div class="bazis-items">
                        <div class="logo-bazis-footer">
                            <a :href="setup.logo_bazis.link" target="_blank">
                                <img :src="setup.logo_bazis.img" alt="">
                            </a>
                        </div>
                        <div class="bazis-awards">
                            <div class="award" v-for="(item , index) in setup.footer_awards" :key="index">
                                <img :src="item.img" alt="">
                            </div>
                        </div>
                        <div class="social-items m-social-items">
                            <a :href="setup.footer_social_links.insta" class="social-item" target="_blank">
                                <svg-icon icon-class="instagram" className="icon-instagram"/>
                            </a>
                            <a :href="setup.footer_social_links.face" class="social-item" target="_blank">
                                <svg-icon icon-class="facebook" className="icon-facebook"/>
                            </a>
                            <a :href="setup.footer_social_links.youtube" class="social-item" target="_blank">
                                <svg-icon icon-class="youtube" className="icon-youtube"/>
                            </a>
                            <!-- <a :href="setup.footer_social_links.vk" class="social-item" target="_blank">
                                <svg-icon icon-class="vk" className="icon-vk"/>
                            </a> -->
                            <a :href="setup.footer_social_links.telegram" class="social-item" target="_blank">
                                <svg-icon icon-class="telegram" className="icon-telegram"/>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="footer-desc">
                        <div class="desc-of-suite">
                            <p>{{setup.footer_zakon_desc}}</p>
                            <p>{{setup.footer_zakon_desc_second}}</p>
                        </div>
                        <div class="copyright">
                            <p>{{setup.copyright}}</p>
                            <a href="https://sales.bazis.kz/privacy-policy" target="_blank" class="link-to-policy">
                                <span v-if="globalLang == ''">Политика конфиденциальности</span>
                                <span v-else>Құпиялылығы саясаты</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="social-items">
                        <a :href="setup.footer_social_links.insta" class="social-item" target="_blank">
                            <svg-icon icon-class="instagram" className="icon-instagram"/>
                        </a>
                        <a :href="setup.footer_social_links.face" class="social-item" target="_blank">
                            <svg-icon icon-class="facebook" className="icon-facebook"/>
                        </a>
                        <a :href="setup.footer_social_links.youtube" class="social-item" target="_blank">
                            <svg-icon icon-class="youtube" className="icon-youtube"/>
                        </a>
                         <!-- <a :href="setup.footer_social_links.vk" class="social-item" target="_blank">
                            <svg-icon icon-class="vk" className="icon-vk"/>
                        </a> -->
                        <a :href="setup.footer_social_links.telegram" class="social-item" target="_blank">
                            <svg-icon icon-class="telegram" className="icon-telegram"/>
                        </a>
                    </div>
                    <div class="developed-team">
                        <!-- <div class="form-of-errors">
                            <a href="#"><p>Сообщить об ошибке</p></a>
                        </div> -->
                        <div class="made-in">
                            Developed by 
                            <a href="#">{{setup.victo_name}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    export default {
        name: 'AppFooter',
        data () {
            return {
                globalLang: window.GlobalLang, 
            }
        },
        components: {
        },
        methods: {
            openFormDeveloper () {
                var btn = $('.form-of-errors a'),
                    form = $('.form-developer'),
                    close = $('.btn-close-form-developer');
                btn.on('click', function(e){
                    e.stopPropagation();
                    e.preventDefault();
                    form.addClass('open');
                });
                close.on('click', function(e){
                    form.removeClass('open');
                });
                // $(window).scroll(function() {
                //     if ($(window).width() > 1024) {
                //         if (form.hasClass('open')) {
                //             form.removeClass('open');
                //         }
                //     }
                // });
                // $(document).on('click', function closeMenu (e){
                //     if(btn.has(e.target).length === 0){
                //         if(form.has(e.target).length === 0) {
                //             form.removeClass('open');
                //         }
                //     } else {
                //         $(document).one('click', closeMenu);
                //     }
                // });
            }
        },
        computed: {
            setup() {
                return this.$store.state.pageSetup
            }
        },
        created() {
        },
        mounted() {
            this.$store.watch(
                (state) => state.pageSetup,
                (newValue) => {
                    if (newValue)
                    this.openFormDeveloper();
                }
            )
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/footer/footer.scss';
</style>